import * as localforage from "localforage"; // this works!!!
class DBStorage {
  constructor() {
    localforage.config({
      name: "DAM Storage",
    });
    localforage.setDriver([localforage.WEBSQL, localforage.INDEXEDDB]);
  }

  get(key) {
    return localforage.getItem(key);
  }

  set(key, value) {
    return localforage.setItem(key, value);
  }

  remove(key) {
    return localforage.removeItem(key);
  }

  DELETE_ALL() {
    return localforage.clear();
  }

  listKeys() {
    return localforage.keys();
  }
}
const dbstorage = new DBStorage();
export default dbstorage;
